/** Field types hidden from UI until editor/signing support is ready. */
const HIDDEN_FIELD_TYPES = new Set(['dropdown', 'radio', 'stamp']);

export function isHiddenFieldType(type) {
  return HIDDEN_FIELD_TYPES.has(String(type || '').toLowerCase());
}
